import { getCurrentDomain } from '@/utils/domainConfig'

const domainLabels: Record<string, string> = {
  'opo.it.com': 'opo.it.com',
  'nwf.so': 'nwf.so',
}

export function RetiredDomainPage() {
  const domain = getCurrentDomain().replace(/^www\./, '')
  const label = domainLabels[domain] ?? 'This domain'

  return (
    <main className="min-h-screen flex items-center justify-center bg-white px-6 text-center text-gray-900">
      <div className="max-w-lg">
        <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-500 mb-4">
          {label}
        </p>
        <h1 className="text-4xl font-semibold tracking-tight mb-4">
          Reserved for future use
        </h1>
        <p className="text-base text-gray-600">
          This domain is reserved. No public service is currently available here.
        </p>
      </div>
    </main>
  )
}

export default RetiredDomainPage
